<template>
  <div class="mapstyle">
    <div class="p-line"></div>
    <!-- <div class="p-lable">{{ propertyData.lable }}</div> -->
    <div class="p-opacityslider-wrap">
      <div class="chooseStyle">
        <p>模板样式</p>
        <el-select size="mini" v-model="statusStyle" placeholder="选择样式">
          <el-option
            v-for="(key, item) in mapStyle"
            :key="key"
            :label="item"
            :value="item"
            @click="selectOption"
          >
          </el-option>
        </el-select>
      </div>
      <!-- <div class="demo-input-suffix">
        自定义样式：
        <el-input placeholder="请输入自定义样式"  v-model="input1"> </el-input>
      </div> -->
    </div>
  </div>
</template>

<script>
const _mapBStyle = {};
var _AutoImport_mapBStyle = () => {
  return new Promise(function(resolve) {
    const path = require('path');
    const files = require.context('@/components/properties/mapStyle/mapBStyle', false, /\.js$/);
    files.keys().forEach(key => {
      const name = path.basename(key, '.js');
      _mapBStyle[name] = files(key).default || files(key);
    });
    resolve(_mapBStyle);
  });
};
export default {
  name: 'mapStyle',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  watch: {
    propertyData: {
      deep: true,
      handler: function(newValue) {
        console.log('newValue: ', newValue);
        this.initStyle();
      },
    },
  },
  data() {
    return {
      value: this.propertyData.mapStyle.value,
      statusStyle: 'normal',
      mapStyle: {},
      mapList: {},
      mapTStyle: {
        标准: 0,
        黑色: 1,
        靛蓝: 2,
      },
      mapAStyle: {
        标准: 0,
        幻影黑: 1,
        月光银: 2,
        远山黛: 3,
        草色青: 4,
        雅士灰: 5,
        涂鸦: 6,
        马卡龙: 7,
        靛青蓝: 8,
        极夜蓝: 9,
        酱籽: 10,
      },
      mapBStyle: {},
      mapTList: {
        0: '标准',
        1: '黑色',
        2: '靛蓝',
      },
      mapAList: {
        0: '标准',
        1: '幻影黑',
        2: '月光银',
        3: '远山黛',
        4: '草色青',
        5: '雅士灰',
        6: '涂鸦',
        7: '马卡龙',
        8: '靛青蓝',
        9: '极夜蓝',
        10: '酱籽',
      },
      mapBList: {},
    };
  },

  created() {
    this.initStyle();
  },
  methods: {
    initStyle() {
      var that = this;
      switch (this.propertyData.mapType.value.type) {
        case 0:
          that.mapStyle = that.mapTStyle;
          that.mapList = that.mapTList;
          that.statusStyle = that.mapList[that.value.checkedId];
          break;
        case 1:
          that.mapStyle = that.mapAStyle;
          that.mapList = that.mapAList;
          that.statusStyle = that.mapList[that.value.checkedId];
          break;
        case 2:
          _AutoImport_mapBStyle().then(function(res) {
            let style = {
              标准: 0,
            };
            let styleList = {
              0: '标准',
            };
            let index = 1;
            for (var key in res) {
              style[key] = index;
              styleList[index] = key;
              index++;
            }
            that.mapBStyle = style;
            that.mapBList = styleList;
            that.mapStyle = that.mapBStyle;
            that.mapList = that.mapBList;
            that.statusStyle = that.mapList[that.value.checkedId];
          });

          break;

        default:
          break;
      }
    },
    selectOption() {
      this.value.checkedId = this.mapStyle[this.statusStyle];
      /* 更新数据 */
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: this.value,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mapstyle {
  width: 100%;
  // padding-bottom: 10px;
  box-sizing: border-box;
  .p-lable {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    color: #5b5c66;
    font-size: 12px;
    line-height: 30px;
  }
}
.demo-input-label {
  display: inline-block;
  width: 130px;
}
.p-opacityslider-wrap {
  padding: 10px 0px;
}
.chooseStyle > {
  div {
    display: flex;
    align-items: center;
  }
  p {
    box-sizing: border-box;
    width: 100px;
    height: 30px;
    color: #a0a1b4;
    font-size: 14px;
    line-height: 30px;
  }
}
.chooseStyle {
  padding: 0 15px;
  display: flex;
  align-items: center;
  .el-select {
    width: 192px;

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);

      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
.mapstyle .p-line {
  width: 100%;
  height: 1px;
  background-image: linear-gradient(to left, rgba(204, 204, 204, 0), #8f8f8f, rgba(204, 204, 204, 0));
  margin-bottom: 5px;
}
</style>
